import React, { useEffect, useState } from "react";
import {useNavigate} from 'react-router-dom'
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { walletZodSchema } from "../../ZodSchemas/RoyaltiesAccountSchema";
import { royaltiesService } from "../../services";
import Spinner from "../../components/UI/Spinner";
import ErrorModal from "../../components/UI/Error";

const WalletUpdateForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(walletZodSchema),
    defaultValues: {
      accountName: "",
      bankName: "",
      accountNumber: "",
    },
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate()
  useEffect(() => {
    const fetchWallet = async () => {
      setLoading(true);
      setError(false);
      try {
        const wallet = await royaltiesService.getArtisteRoyaltiesAccount();
        reset({
          accountName: wallet?.accountName || "",
          bankName: wallet?.bankName || "",
          accountNumber: wallet?.accountNumber || "",
        });
     
      } catch (err) {
        console.error("Error fetching wallet:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchWallet();
  }, [reset]);

  const onSubmit = async (data) => {
    try {
     await royaltiesService.updateRoyaltiesAccount(data);
     navigate("/user/my-royalties")
    } catch (err) {
      setError(true)
      setErrorMessage({message: "update" });
      console.error("Error updating wallet:", err);
      
    }
  };

  if (loading) {
    return (
      <div className="grid place-content-center h-[50vh]">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title="Error"
        message={`Unable to  ${errorMessage?.message || "load"} wallet info. Please try again.`}
      />
    );
  }

  return (
    <div className="max-w-xl mx-auto bg-white p-6 rounded-2xl shadow-lg mt-8">
      <h2 className="text-2xl font-bold text-yellow-500 mb-0">Update Wallet Info</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-2 pt-0">
        <div>
          <input
            type="text"
            {...register("accountName")}
            className={`${errors.accountName && "inputError"}`} placeholder="Account Name" 
          />
          {errors.accountName && (
            <p className="formTextError">{errors.accountName.message}</p>
          )}
        </div>

        <div>
          <input
            type="text"
            {...register("bankName")}
             className={`${errors.bankName && "inputError"}`} placeholder="Bank Name" 
          />
          {errors.bankName && (
            <p className="text-red-500 text-sm mt-1">{errors.bankName.message}</p>
          )}
        </div>

        <div>
          <input
            type="text"
            {...register("accountNumber")}
             className={`${errors.accountNumber && "inputError"}`} placeholder="Account Name" 
          />
          {errors.accountNumber && (
            <p className="formTextError">{errors.accountNumber.message}</p>
          )}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="formSubmitBtn"
        >
          {isSubmitting ? "Updating..." : "Update Wallet"}
        </button>
      </form>
    </div>
  );
};

export default WalletUpdateForm;